.modal {
  max-width: calc(100vw - 32px);
  width: min(560px, calc(100vw - 32px));
}

.header {
  padding: 28px 32px 18px;
}

.body {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 8px 32px 24px;
}

.current {
  align-items: center;
  background: var(--color-surface, #f8fafc);
  border: 1px solid var(--color-border, #e5e7eb);
  border-radius: 14px;
  display: flex;
  gap: 12px;
  padding: 14px 16px;
}

.current-icon {
  align-items: center;
  background: var(--color-background, #fff);
  border: 1px solid var(--color-border, #e5e7eb);
  border-radius: 12px;
  color: var(--color-primary, #4f46e5);
  display: inline-flex;
  flex: 0 0 auto;
  height: 40px;
  justify-content: center;
  width: 40px;
}

.current-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.presets {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.preset-button {
  border-radius: 14px;
  justify-content: center;
  min-width: 0;
  width: 100%;
}

.custom {
  background: var(--color-background, #fff);
  border: 1px solid var(--color-border, #e5e7eb);
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px;
}

.duration-input {
  width: 100%;
}

.date-time-picker {
  gap: 10px;
}

.date-time-picker input {
  height: 44px;
}

.date-time-picker input[type='time'] {
  width: 142px;
}

.footer {
  border-top: 1px solid var(--color-border, #e5e7eb);
  padding: 18px 32px 28px;
}

@media (max-width: 480px) {
  .header {
    padding: 24px 20px 16px;
  }

  .body {
    padding: 4px 20px 20px;
  }

  .presets {
    grid-template-columns: 1fr;
  }

  .date-time-picker {
    align-items: stretch;
    flex-direction: column;
  }

  .date-time-picker input,
  .date-time-picker input[type='time'] {
    width: 100%;
  }

  .footer {
    align-items: stretch;
    flex-direction: column-reverse;
    padding: 16px 20px 24px;
  }
}
